import NewBanner from './NewBanner';

export default NewBanner;
